import { DateTime } from "luxon";

// The timezone-picker library renders a static abbreviation from its bundled
// timezones.json (e.g. always "PST" for America/Los_Angeles), which ignores DST.
// These helpers compute the current, DST-aware abbreviation via luxon instead.

export function current_abbreviation(zone: string): string {
	const dt = DateTime.now().setZone(zone);
	return dt.isValid ? dt.toFormat("ZZZZ") : zone;
}

// The library also renders a <select> with option text "<IANA> (<static abbr>)"
// and (if select2 is loaded) wraps it in select2. Rewrite each option's text to
// use the live abbreviation. Call this right after .timezonePicker(...) inits.
export function refresh_dropdown_abbreviations(picker_el: any): void {
	const select = picker_el.find("select.country-lov");
	if (!select.length) {
		return;
	}

	// select2 caches rendered option text, so tear it down before rewriting and
	// re-init afterwards so both the closed display and the open list update.
	const had_select2 = !!select.data("select2");
	if (had_select2) {
		select.select2("destroy");
	}

	select.find("option").each((_index: number, option: HTMLOptionElement) => {
		const value = option.getAttribute("value");
		if (value) {
			option.textContent = `${value} (${current_abbreviation(value)})`;
		}
	});

	if (had_select2) {
		select.select2();
	}
}

// The library renders quick-link buttons with a hardcoded label (e.g. "PST")
// pointing at an IANA zone. Rewrite each label to the live abbreviation so it
// tracks DST (PST -> PDT). Friendly labels whose target has no named
// abbreviation (e.g. "UK" -> Europe/London, "UTC") are left untouched so we
// don't replace them with a bare numeric offset like "GMT+1".
export function refresh_quicklink_abbreviations(picker_el: any): void {
	picker_el
		.find(".quick-link span")
		.each((_index: number, span: HTMLSpanElement) => {
			const target = span.getAttribute("data-select");
			// Friendly labels (e.g. "UTC") map to a non-IANA value; leave as-is.
			if (!target || !target.includes("/")) {
				return;
			}
			const abbr = current_abbreviation(target);
			// luxon falls back to a numeric offset (e.g. "GMT+1") when a zone has
			// no named abbreviation — keep the original friendly label in that case.
			if (/^(?:GMT|UTC)[+-]/.test(abbr)) {
				return;
			}
			span.textContent = abbr;
		});
}
